import { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import type { IntlShape } from 'react-intl';

import { DevTools } from '@/components/layout/DevTools';
import { ThemeProvider } from '@/components/providers/ThemeProvider';
import type { Toaster } from '@/hooks/use-toast';

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
  title: string | undefined;
  formatMessage: IntlShape['formatMessage'];
  toast: Toaster;
}>()({
  component: RootComponent,
});

function RootComponent() {
  return (
    <ThemeProvider defaultTheme="system">
      <Outlet />
      <DevTools />
    </ThemeProvider>
  );
}
